import { render, staticRenderFns } from "./PrescriptionPrint.vue?vue&type=template&id=5989a8b3&scoped=true"
import script from "./PrescriptionPrint.vue?vue&type=script&lang=js"
export * from "./PrescriptionPrint.vue?vue&type=script&lang=js"
import style0 from "./PrescriptionPrint.vue?vue&type=style&index=0&id=5989a8b3&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5989a8b3",
  null
  
)

export default component.exports